import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { isMobile } from 'react-device-detect'
import cx from 'classnames'
import MaterialIcon from 'material-icons-react'

import { scrollHeroUnit, scrollHeroUnitMobile, setFilterScrollOffset } from '../../../actions'

import AutosuggestIndustry from './autosuggest-industry'
import AutosuggestLocation from './autosuggest-location'

import './filter.scss'

let scrollOffsetSet = false

class Filter extends Component {

  state = {
    lastScrollOffsetMobile: 0,
    scrollDirection: 0,
    expanded: false
  }
  
  onScroll (e) {
    if (!isMobile) {
      if (window.pageYOffset > this.props.scrollOffset) {
        this.props.dispatch(scrollHeroUnit(true))
      } else {
        this.props.dispatch(scrollHeroUnit(false))
      }
    } else {
      if (window.pageYOffset > this.props.scrollOffset) {
        this.props.dispatch(scrollHeroUnitMobile(true))
      } else {
        this.props.dispatch(scrollHeroUnitMobile(false))
      }
    }
    
    const scrollDirection = window.pageYOffset > this.state.lastScrollOffsetMobile ? 1 : -1
    this.setState({ scrollDirection })
    this.setState({ lastScrollOffsetMobile: window.pageYOffset })
  }
  
  componentDidMount () {
    const thisNode = ReactDOM.findDOMNode(this)

    if (scrollOffsetSet === false) {

      const scrollOffset = isMobile ? 
                           thisNode.offsetTop + thisNode.offsetHeight :
                           386


      this.props.dispatch(setFilterScrollOffset(scrollOffset))
      scrollOffsetSet = true
    }

    this.onScroll = this.onScroll.bind(this)
    
    window.addEventListener('mousewheel', this.onScroll, false)
    window.addEventListener('scroll', this.onScroll, false)
  }

  componentWillUnmount () {
    window.removeEventListener('mousewheel', this.onScroll)
    window.removeEventListener('scroll', this.onScroll)
  }

  render () {
    const { scrollDirection } = this.state
    const {
      company,
      location,
      isIndustryFocused,
      isLocationFocused,
      suggestionsIndustry,
      suggestionsLocation
    } = this.props

    const valueInputIndustry = company === 'all' ?
                               '' :
                               company
    const valueInputLocation = location === 'anywhere' ?
                               '' :
                               location
    
    const classScroll = cx(
      'app-filter-container',
      'container-small',
      { 'is-mobile': isMobile },
      { 'scroll-mobile': scrollDirection === -1 && isMobile }
    )

    const classIndustryFilter = cx(
      'filter-industry',
      { 'is-focused': isIndustryFocused }
    )

    const classLocationFilter = cx(
      'filter-location',
      { 'is-focused': isLocationFocused }
    )
    
    return (
      <div className={classScroll}>
          <div className="filter-controls">
            <div className={classIndustryFilter}>
              <div className="filter-icon-container">
                <MaterialIcon icon="search" />
                <MaterialIcon icon="search" />
              </div>
              <AutosuggestIndustry 
                defaultValue={valueInputIndustry}
                placeholder='Industry, Company, Service'
                suggestions={suggestionsIndustry}
              />
            </div>
            <div className={classLocationFilter}>
              <div className="filter-icon-container">
                <MaterialIcon icon="location_on" />
                <MaterialIcon icon="location_on" />
              </div>
              <AutosuggestLocation 
                defaultValue={valueInputLocation}
                placeholder="Anywhere"
                suggestions={suggestionsLocation} 
              />
            </div>
          </div>
      </div>
    )
  }
}

export default compose(
    withRouter,
    connect((state, props) => {
        return {
            partners: state.firebase.data['companies'],
            company: props.match.params.what,
            location: props.match.params.where,
            scrollOffset: state.uiReducer.scrollOffset,
            isIndustryFocused: state.uiReducer.isIndustryFilterFocused,
            isLocationFocused: state.uiReducer.isLocationFilterFocused
        }
    })
)(Filter)


// WEBPACK FOOTER //
// ./src/components/hero-unit/filter/index.jsx